import KumosearchError from "./KumosearchError";

export default class RequestMalformed extends KumosearchError {}
